import React,{Component} from 'react';
import {connect} from 'react-redux';
import HistoryReview from './HistoryReview';
//import DriversReview from './DriversReview';
//import VehiclesReview from './VehiclesReview';
import DriverSection from './driver/DriverSectionComponent';
import VehicleSection from './vehicle/VehicleComponent';
import {Redirect } from 'react-router-dom';


import { updateTitle } from '../SectionTitle/actions';


const disclaimer = `<p class="disclaimerText">By purchasing this policy, you agree that the information used to provide you with a price has been confirmed by you.</p>`;

const setHtml = (markup) => {
    return {
        __html: markup
    }
}

const mapStateToProps = (state) => {
    //
    return {
        state: state
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateTitle: (titleObj) => dispatch(updateTitle(titleObj))
    }
}

class QuoteReview extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);

        //alert('test');
        this.props.updateTitle({
            title: '<h1>Buy now for</h1>',
            subTitle: `<div>
                <p>
                <span class="estimateMonths">$${this.props.state.userConfirmation.estimate}</span> for 6 months
                </p>
                ${disclaimer}
                <p>
                <button class="btn btn-success">Buy Now Online 
                <i class="fa fa-laptop" aria-hidden="true"></i>
                </button>
                </p>
                <p>
                    <button class="btn btn-primary">
                        Buy Now Over the Phone
                        <i class="fa fa-phone" aria-hidden="true"></i>
                    </button>
                </p>
            </div>`,
            image: '<i class="fa fa-trophy" aria-hidden="true"></i>'
        });
    }
    render(){
        const {reviewData} = this.props.state.ReviewReducer;
        if(reviewData){
        return(
            <div>
                <DriverSection data={reviewData.subjects} />
                <VehicleSection data={reviewData.vehicles} />
                <HistoryReview defaultData={reviewData.History} vehicles={reviewData.vehicles}/>
                <div className="quote-center">
                <p>
                <span className="estimateMonths">${this.props.state.userConfirmation.estimate}</span> for 6 months
                </p>
                <div dangerouslySetInnerHTML={setHtml(disclaimer)}></div>
                <p>
                <button className="btn btn-success">
                    {`Buy Now Online `}
                <i className="fa fa-laptop" aria-hidden="true"></i>
                </button>
                </p>
                <p>
                    <button className="btn btn-primary">
                        {`Buy Now Over the Phone `}
                        <i className="fa fa-phone" aria-hidden="true"></i>
                    </button>
                </p>
                </div>
            </div>
        );
        }
        else{
            return(
                <Redirect to="/" />
            );
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuoteReview);




// WEBPACK FOOTER //
// ./src/QuoteReview/index.js